import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import './Navbar.css';
import logo from '../assets/logo.jpeg';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Check if we're on dashboard page to hide navigation links
  const isDashboardPage = location.pathname === '/dashboard';

  if (isDashboardPage) {
    return null;
  }

  return (
    <nav className="cricket-navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" className="brand-link">
            <div className="brand-icon">
              <img 
                src={logo}
                alt="MSKICA Cricket Academy Logo" 
                className="academy-logo"
                onError={(e) => {
                  console.log('Logo failed to load');
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div style="font-size: 2.4rem;">🏏</div>';
                }}
                onLoad={() => console.log('Logo loaded successfully')}
              />
            </div>
            <div className="brand-text">
              <span className="brand-name">{process.env.REACT_APP_ACADEMY_NAME || 'MSKICA Cricket Academy'}</span>
              <span className="brand-tagline">{process.env.REACT_APP_ACADEMY_TAGLINE || 'Performance Excellence'}</span>
            </div>
          </Link>
        </div>
        
        <div className="navbar-menu">
          <div className="navbar-nav">
              {user ? (
                <>
                  <Link 
                    to="/dashboard" 
                    className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                  >
                    <span className="nav-icon">📊</span>
                    Dashboard
                  </Link>
                  
                  {user.user_type === 'coach' && (
                    <Link 
                      to="/admin" 
                      className={`nav-link ${isActive('/admin') ? 'active' : ''}`}
                    >
                      <span className="nav-icon">👨‍🏫</span>
                      Admin
                    </Link>
                  )}
                  
                  <Link 
                    to="/profile" 
                    className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
                  >
                    <span className="nav-icon">👤</span>
                    Profile
                  </Link>
                </>
              ) : (
                <>
                  <button
                    className="nav-link"
                    onClick={() => scrollToSection('about')}
                  >
                    <span className="nav-icon">ℹ️</span>
                    About Us
                  </button>
                  <button
                    className="nav-link"
                    onClick={() => scrollToSection('programs')}
                  >
                    <span className="nav-icon">🏏</span>
                    Programs
                  </button>
                  <button
                    className="nav-link"
                    onClick={() => scrollToSection('coaching-team')}
                  >
                    <span className="nav-icon">👨‍🏫</span>
                    Coaching Team
                  </button>
                  <Link 
                    to="/login" 
                    className={`nav-link ${isActive('/login') ? 'active' : ''}`}
                  >
                    <span className="nav-icon">🔐</span>
                    Login
                  </Link>
                  <Link 
                    to="/register" 
                    className={`nav-link ${isActive('/register') ? 'active' : ''}`}
                  >
                    <span className="nav-icon">📝</span>
                    Register
                  </Link>
                </>
              )}
          </div>
          
          <div className="navbar-actions">
            {user && (
              <div className="user-menu">
                <div className="user-info">
                  <span className="user-greeting">Hello,</span>
                  <span className="user-name">{user.first_name} {user.last_name}</span>
                  <span className="user-type">({user.user_type})</span>
                </div>
                <button 
                  onClick={logout}
                  className="logout-button"
                >
                  <span className="logout-icon">🚪</span>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
